import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // 👈 Ajouté

import fr from "../locales/fr/translation.json";
import en from "../locales/en/translation.json";

i18n
  .use(LanguageDetector) // 👈 Détecte et garde la langue dans localStorage
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: "fr", // langue de secours
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // 👇 Permet de sauvegarder la langue dans le navigateur
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
